export enum inputCategories {
  ratePerHour = "RatePerHour",
  moneySpent = "MoneySpent",
  timeSpent = "TimeSpent",
}
